import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { AssignmentDTO } from '../model/assignments/assignment-management-dto.model';

@Injectable()
export class AssignmentsApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getAssignments({ offset, limit, searchBy = '', userType = '', bid = 0, isSupervisorOnly = false, unassigned = false}:
        {
            offset: number,
            limit: number,
            searchBy?: string,
            userType?: string,
            bid?: number,
            isSupervisorOnly?: boolean,
            unassigned?: boolean
        }) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('searchBy', String(searchBy))
            .append('userType', String(userType))
            .append('bid', String(bid))
            .append('isSupervisorOnly', String(isSupervisorOnly))
            .append('unassigned', String(unassigned));

        return this.http.get<AssignmentDTO[]>(this.baseUri + '/assignments/Get', { params });
    }

    addBuildingAssignments(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.post(this.baseUri + '/assignments/addBuildingAssignments',  buildingAssignments );
    }

    removeBuildingAssignments(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.put(this.baseUri + '/assignments/removeBuildingAssignments', buildingAssignments );
    }

    addBuildingLeads(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.post(this.baseUri + '/assignments/addBuildingLeads',  buildingAssignments );
    }

    removeBuildingLeads(buildingAssignments: {buildingId: number | null, userIds:string[]}) {
        return this.http.put(this.baseUri + '/assignments/removeBuildingLeads', buildingAssignments );
    }
}
